"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _downloadIE = _interopRequireDefault(require("core.ui-module_site-styling/lib/images/downloadIE.png"));
var _downloadFF = _interopRequireDefault(require("core.ui-module_site-styling/lib/images/downloadFF.png"));
var _downloadReader = _interopRequireDefault(require("core.ui-module_site-styling/lib/images/downloadReader.png"));
var _core = require("core.ui-module_site-components");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class SiteRequirements extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      isShow: props.isShow,
      closeModal: props.closeModal
    };
  }
  toggleShow(isShow) {
    this.setState({
      isShow
    });
  }
  render() {
    const {
      isShow,
      closeModal
    } = this.state;
    const modalRoot = document.getElementById('modal-root');
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("a", {
      onClick: () => {
        this.toggleShow(true);
      },
      className: ""
    }, "Site Requirements"), isShow && /*#__PURE__*/_react.default.createElement(_core.Modal, {
      header: "Site Requirements",
      footer: /*#__PURE__*/_react.default.createElement("div", null),
      closeModalCallback: () => {
        if (typeof closeModal !== 'undefined') {
          closeModal();
        } else {
          this.toggleShow(false);
        }
      },
      portalContainer: modalRoot
    }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h2", null, "Site Requirements And Security"), /*#__PURE__*/_react.default.createElement("h3", null, "Cookies"), /*#__PURE__*/_react.default.createElement("p", {
      align: " justify"
    }, "We realize that a growing number of visitors to our Web site are concerned about privacy and disable cookies in their browser configuration. A cookie is a small piece of information sent by a web site to a web browser so that it can be later read back from that web browser. Cookies expire when a browser is exited; however, if a browser is left open, a third party could potentially access account data."), /*#__PURE__*/_react.default.createElement("p", {
      align: " justify"
    }, "MissionSquare Retirement has diminished this exposure by implementing session tracking which will prevent a third party from navigating to prior screens. Session tracking places a heavy reliance on the use of cookies; thus ", /*#__PURE__*/_react.default.createElement("strong", null, "cookies must be enabled "), ' ', "to use this site."), /*#__PURE__*/_react.default.createElement("h3", null, "Software"), /*#__PURE__*/_react.default.createElement("p", {
      align: " justify"
    }, "To make full use of our site, you will need a modern web browse You may also require additional helper software to be installed on your computer."), /*#__PURE__*/_react.default.createElement("h3", null, "Microsoft Internet Explorer"), /*#__PURE__*/_react.default.createElement("a", {
      href: "http://www.microsoft.com/windows/ie/default.mspx",
      rel: "noopener noreferrer",
      target: "_blank"
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: _downloadIE.default
    }), /*#__PURE__*/_react.default.createElement("br", null), " Go to the Internet Explorer download page"), /*#__PURE__*/_react.default.createElement("h3", null, "Mozilla Firefox"), /*#__PURE__*/_react.default.createElement("a", {
      href: "http://www.mozilla.com/firefox",
      rel: "noopener noreferrer",
      target: "_blank"
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: _downloadFF.default
    }), /*#__PURE__*/_react.default.createElement("br", null), " Go to the Mozilla Firefox download page"), /*#__PURE__*/_react.default.createElement("h3", null, "Adobe Reader"), /*#__PURE__*/_react.default.createElement("p", {
      align: " justify"
    }, "To view PDF files, you will need software that can open them, such as the free Adobe Reader."), /*#__PURE__*/_react.default.createElement("a", {
      href: "http://www.adobe.com/products/acrobat/readstep2.html",
      rel: "noopener noreferrer",
      target: "_blank"
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: _downloadReader.default
    }), /*#__PURE__*/_react.default.createElement("br", null), " Go to the Adobe Reader download page"), /*#__PURE__*/_react.default.createElement("h3", null, "Password Security"), /*#__PURE__*/_react.default.createElement("p", {
      align: " justify"
    }, "To preserve the security of your password, we encourage you to change it on a regular basis."), /*#__PURE__*/_react.default.createElement("p", {
      align: " justify"
    }, "If you have an existing account with MissionSquare Retirement, you are required to enter our website with a User ID and Password."))));
  }
}
exports.default = SiteRequirements;
SiteRequirements.propTypes = {
  isShow: _propTypes.default.bool,
  closeModal: _propTypes.default.func
};
SiteRequirements.defaultProps = {
  isShow: undefined,
  closeModal: undefined
};
//# sourceMappingURL=SiteRequirements.js.map